import { useCnSite } from '@/hooks/use-cn-site';
const { cnEdition } = useCnSite();

const hotjarObj = {
  qa: '3841279',
  pro: '3827137',
};
const joperateAppkey = {
  qa: 'b938f3270dc43960ac78a99a',
  pro: '4c12e9defa870d55a15cbe23',
};
function randomUid() {
  const keyStr = 'mtWebPushRandomUid';
  let uid = window.localStorage.getItem(keyStr);
  if (!uid) {
    uid = new Date().getTime().toString(36) + Math.floor(Math.random() * 10000000).toString(36);
    window.localStorage.setItem(keyStr, uid);
  }
  return uid;
}
function getCookie(searchName: string, str?: string) {
  str = str || document.cookie;
  const n = str.indexOf(searchName);
  const cookieEnd = str.indexOf(';', n);
  const cookieStar =
    n === -1
      ? false
      : decodeURIComponent(
          str.substring(n + searchName.length, cookieEnd > n ? cookieEnd : str.length),
        );
  return cookieStar ? cookieStar.split('=')[1] : false;
}
function getBaseInfo() {
  const url = location.href;
  const urlArr = url.split('/');
  let product_type = 'Console';
  let url_product_type = '';
  let orgId = '';
  let appkey = '';
  if (location.hash) {
    const hashArr = location.hash.slice(2).split('/');
    const p = hashArr[0];

    if (p && url.includes(`${p}/#/${p}`)) {
      // eslint-disable-next-line camelcase
      url_product_type = p;
    }
    if (hashArr.length > 1 && hashArr[1].length > 20) {
      orgId = hashArr[1];
    }
    if (hashArr.length > 2 && hashArr[2].length > 14) {
      appkey = hashArr[2];
    }
  }
  // eslint-disable-next-line camelcase
  const product_id = ['app-push', 'web-push', 'whatsapp', 'otp'].includes(url_product_type)
    ? appkey
    : orgId;

  const typeMap = {
    console: 'Console',
    sms: 'SMS',
    email: 'Email',
    otp: 'OTP',
    whatsapp: 'WhatsApp',
    'app-push': 'AppPush',
    'web-push': 'WebPush',
  } as any;

  product_type = ['sms', 'email', 'app-push', 'web-push', 'whatsapp', 'otp', 'console'].includes(
    url_product_type,
  )
    ? typeMap[url_product_type]
    : product_type;

  return {
    product_id,
    product_type: 'Console',
    // eslint-disable-next-line camelcase
    page_name: product_type + '_' + urlArr[urlArr.length - 1],
    page_url: url,
    language_browser: navigator.language,
    language_page: getCookie('i18n_redirected') || 'en_US',
  };
}
let keyStr = '';
function hotjar(h: any = window, o = document, t = 'https://static.hotjar.com/c/hotjar-') {
  h.hj =
    h.hj ||
    function () {
      // eslint-disable-next-line prefer-rest-params
      (h.hj.q = h.hj.q || []).push(arguments);
    };
  h._hjSettings = { hjid: hotjarObj[keyStr as 'qa' | 'pro'], hjsv: 6 };
  const a = o.getElementsByTagName('head')[0];
  const r = o.createElement('script');
  r.async = true;
  r.src = t + h._hjSettings.hjid + '.js?sv=' + h._hjSettings.hjsv;
  a.appendChild(r);
}

const arr: any[] = [];
// 设置用户属性
if (typeof window !== 'undefined' && !cnEdition) {
  keyStr = location.host.startsWith('www') ? 'pro' : 'qa';
  hotjar();
}
function joperate(
  attributes: { [key: string]: string | string[] | number | boolean },
  name = 'click',
) {
  if (
    Object.keys(attributes).includes('is_success') ||
    Object.keys(attributes).includes('failure_reason')
  ) {
    name = 'click_result';
  }
  const j = (window as any).JOperateInterface;
  if (j) {
    j.onEvent({ name, attributes });
  } else {
    arr.push({ name, attributes });
  }
}
// 登录后调用，由于是登录操作所以不重试 设置用户标识
function account(account_id: string, account_email: string) {
  const j = (window as any).JOperateInterface;
  const userIDs = Object.assign({ account_id, account_email }, { browser_rid: randomUid() });
  const user = { completion: () => null, userIDs };
  if (j) {
    j.identifyAccount(user);
  }
}
// 进入页面上报
function pageVisit() {
  joperate(getBaseInfo(), 'page_visit');
}
export type ClickType = {
  page_module?: string;
  is_success?: boolean;
  failure_reason?: string;
  item_form?: string[] | string;
  item_form2?: string[] | string;
  click_item: string;
  product_type?:
    | 'Website'
    | 'Console'
    | 'AppPush'
    | 'WebPush'
    | 'WhatsApp'
    | 'Email'
    | 'SMS'
    | 'Segment'
    | 'OTP';
  /** AppPush、WebPush传appkey，WhatsApp传WABAID，Email和SMS传组织ID */
  product_id?: string;
};
// 事件点击上报
function pageClick(data: ClickType) {
  const obj = Object.assign(getBaseInfo(), { page_module: '默认' });
  joperate(Object.assign(obj, data));
}
let has = false;

export default function () {
  const fucObj = { pageClick, account, pageVisit };
  if (typeof window === 'undefined' || cnEdition) {
    return fucObj;
  }
  const w: any = window;
  const st = setTimeout;

  const d = document;
  const s = 'script';

  if (!has) {
    has = true;
  } else {
    return fucObj;
  }

  const j = d.createElement('script');
  j.async = true;
  j.src = 'https://report.srcEngagelab.com/web/report/html/joperate-web.min.js';
  const i = () => {
    if (d.body) {
      w.JOperateInterface.init({
        appKey: joperateAppkey[keyStr as 'qa' | 'pro'],
        debugMode: false,
        channel: 'default-channel',
      });
      setTimeout(() => {
        if (arr.length > 0) {
          arr.forEach(obj => {
            w.JOperateInterface.onEvent(obj);
          });
        }
        const pageLan = getCookie('i18n_redirected') || 'en_US';
        const lan = navigator.language;
        w.JOperateInterface.set(
          {
            account_language_page: pageLan,
            account_language_page_all: pageLan,
            account_language_browser: lan,
            account_language_browser_all: lan,
          },
          () => null,
        );
      }, 3000);
    } else st(i, 10);
  };
  j.addEventListener('load', i);
  const s0: any = d.getElementsByTagName(s)[0];
  s0.parentNode.insertBefore(j, s0);

  return fucObj;
}
